module.exports = __webpack_public_path__ + "static/media/help.44f5b3c4.svg";